import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/Home"));
const RegisterPage = lazy(() => import("../pages/auth/Register"));
const SignInPage = lazy(() => import("../pages/auth/SignIn"));
const VerifyEmailPage = lazy(() => import("../pages/auth/VerifyEmail"));
const EmailVerificationPage = lazy(() => import("../pages/auth/EmailVerification"));
const ForgotPasswordPage = lazy(() => import("../pages/auth/ForgotPassword"));
const ForgotPasswordEmailPage = lazy(() => import("../pages/auth/CheckEmailForgotPassword"));
const ResetPasswordPage = lazy(() => import("../pages/auth/ResetPassword"));
const JobsPage = lazy(() => import("../pages/jobs/JobPage"));
const JobDetailsPage = lazy(() => import("../pages/jobs/JobDetails"));
const CompaniesPage = lazy(() => import("../pages/companies/Companies"));
const CompanyDetailPage = lazy(() => import("../pages/companies/CompanyDetails"));
const AboutPage = lazy(() => import("../pages/about/About"));
const PricingPage = lazy(() => import("../pages/pricing/PricingPage"));
const TermsAndConditionPage = lazy(() => import("../pages/terms-and-condition/TermsAndCondition"));
const PostAJobPage = lazy(() => import("../pages/post-a-job/PostAJob"));
const FindJobSeekerPage = lazy(() => import("../pages/find-job-seeker/FindJobSeeker"));
const ContactUsPage = lazy(() => import("../pages/contact/ContactUs"));

const JobSeekerOverviewPage = lazy(() => import("../pages/dashboard/jobSeeker/overView/Overview"));
const JobSeekerNotificationsPage = lazy(() => import("../pages/dashboard/jobSeeker/notifications/NotificationPage"));
const JobSeekerFindJobsPage = lazy(() => import("../pages/dashboard/jobSeeker/findJobs/FindJobs"));
const JobSeekerJobDetailsPage = lazy(() => import("../pages/dashboard/jobSeeker/findJobs/jobDetails/JobDetailsDashboard"));
const JobSeekerAppliedJobsPage = lazy(() => import("../pages/dashboard/jobSeeker/appliedJobs/AppliedJobsPage"));
const JobSeekerSavedJobsPage = lazy(() => import("../pages/dashboard/jobSeeker/savedJobs/SavedJobsPage"));
const JobSeekerCompaniesPage = lazy(() => import("../pages/dashboard/jobSeeker/companies/CompaniesPage"));
const JobSeekerCompanyDetailsPage = lazy(() => import("../pages/dashboard/jobSeeker/companies/companyDetails/CompanyDetailsJobSeeker"));
const JobSeekerMessagesPage = lazy(() => import("../pages/dashboard/jobSeeker/messages/MessagesPage"));
const JobSeekerProfilePage = lazy(() => import("../pages/dashboard/jobSeeker/profile/ProfilePage"));
const JobSeekerPlansBillingPage = lazy(() => import("../pages/dashboard/jobSeeker/plansBilling/PlansBilling"));
const JobSeekerSettingsPage = lazy(() => import("../pages/dashboard/jobSeeker/settings/SettingsPage"));

// employer routes
const EmployerOverviewPage = lazy(() => import("../pages/dashboard/employer/overView/Overview"));
const EmployerCompanyProfilePage = lazy(() => import("../pages/dashboard/employer/company-profile/ProfilePage"));
const EmployerNotificationsPage = lazy(() => import("../pages/dashboard/employer/notifications/Notifications"));
const EmployerMessagesPage = lazy(() => import("../pages/dashboard/employer/messages/Messages"));
const EmployerpostAJobPage = lazy(() => import("../pages/dashboard/employer/post-a-job/PostAJob"));
const EmployerEditAJobPage = lazy(() => import("../pages/dashboard/employer/my-jobs/edit-job/EditJob"));

const EmployerFindJobSeeker = lazy(() => import("../pages/dashboard/employer/findJobSeekers/JobSekkerPage"));
const EmployerMyJobsPage = lazy(() => import("../pages/dashboard/employer/my-jobs/MyJobs"));
const EmployerJobDetailsPage = lazy(() => import("../pages/dashboard/employer/my-jobs/components/jobDetails/JobEmployerDetailsDashboard"));
const EmployerMyJobApplicationPage = lazy(() => import("../pages/dashboard/employer/my-jobs/components/JobApplications"));
const EmployerSavedJobSeekersPage = lazy(() => import("../pages/dashboard/employer/saved-job-seekers/SavedJobSeekers"));
const EmployerPlansBillingPage = lazy(() => import("../pages/dashboard/employer/plansBilling/PlansBilling"));
const EmployerSettingsPage = lazy(() => import("../pages/dashboard/employer/settings/Settings"));

// admin routes
const AdminOverviewPage = lazy(() => import("../pages/dashboard/admin/overview/Overview"));
const AdminManageJobSeekersPage = lazy(() => import("../pages/dashboard/admin/manage-jobSeekers/ManageJobSeekers"));
const AdminManageEmployersPage = lazy(() => import("../pages/dashboard/admin/manageEmployers/ManageEmployers"));
const AdminManageJobsPage = lazy(() => import("../pages/dashboard/admin/manageJobs/ManageJobs"));
const AdminContentManagementPage = lazy(() => import("../pages/dashboard/admin/contentManagement/ContentManagement"));
const AdminSubscriptionAndPlansPage = lazy(() => import("../pages/dashboard/admin/subscriptionAndPlans/SubscriptionAndPlans"));
const AdminAdsPage = lazy(() => import("../pages/dashboard/admin/ads/Ads"));
const AdminSupportCenterPage = lazy(() => import("../pages/dashboard/admin/supportCenter/SupportCenter"));
const AdminSettingsPage = lazy(() => import("../pages/dashboard/admin/settings/Settings"));


const routes = [
    {
      path: "/",
      component: HomePage,
    },
    {
        path: "/register",
        component: RegisterPage,
      },
      {
        path: "/sign-in",
        component: SignInPage,
      },
      {
        path: "/verify-email",
        component: VerifyEmailPage,
      },
      {
        path: "/email-verification",
        component: EmailVerificationPage,
      },
      {
        path: "/forgot-password",
        component: ForgotPasswordPage,
      },
      {
        path: "/forgot-password/email",
        component: ForgotPasswordEmailPage,
      },
      {
        path: "/auth/reset-password",
        component: ResetPasswordPage,
      },
      {
        path: "/jobs",
        component: JobsPage,
      },
      {
        path: "/job-details",
        component: JobDetailsPage,
      },
      {
        path: "/companies",
        component: CompaniesPage,
      },
      {
        path: "/company-details",
        component: CompanyDetailPage,
      },
      {
        path: "/about-us",
        component: AboutPage,
      },
        {
        path: "/pricing",
        component: PricingPage,
      },
        {
        path: "/terms-and-condition",
        component: TermsAndConditionPage,
      },
      {
        path: "/post-a-job",
        component: PostAJobPage,
      },
      {
        path: "/find-job-seeker",
        component: FindJobSeekerPage,
      },
      {
        path: "/contact-us",
        component: ContactUsPage,
      },
      {
        path: "/job-seeker/overview",
        component: JobSeekerOverviewPage,
      },
      {
        path: "/job-seeker/notifications",
        component: JobSeekerNotificationsPage,
      },
        {
        path: "/job-seeker/find-jobs",
        component: JobSeekerFindJobsPage,
      },
   {
        path: "/job-seeker/job-details",
        component: JobSeekerJobDetailsPage,
      },

      
      {
        path: "/job-seeker/applied-jobs",
        component: JobSeekerAppliedJobsPage,
      },
      {
        path: "/job-seeker/saved-jobs",
        component: JobSeekerSavedJobsPage,
      },
         {
        path: "/job-seeker/companies",
        component: JobSeekerCompaniesPage,
      },
         {
        path: "/job-seeker/company-details",
        component: JobSeekerCompanyDetailsPage,
      },
      {
        path: "/job-seeker/messages",
        component: JobSeekerMessagesPage,
      },
      {
        path: "/job-seeker/notifications",
        component: JobSeekerNotificationsPage,
      },
      {
        path: "/job-seeker/profile",
        component: JobSeekerProfilePage,
      },
      {
        path: "/job-seeker/plans-billing",
        component: JobSeekerPlansBillingPage,
      },
      {
        path: "/job-seeker/settings",
        component: JobSeekerSettingsPage,
      },

      {
        path: "/employer/overview",
        component: EmployerOverviewPage,
      },
      {
        path: "/employer/company-profile",
        component: EmployerCompanyProfilePage,
      },
      {
        path: "/employer/notifications",
        component: EmployerNotificationsPage,
      },
      {
        path: "/employer/messages",
        component: EmployerMessagesPage,
      },
      {
        path: "/employer/post-a-job",
        component: EmployerpostAJobPage,
      },
        {
        path: "/employer/my-jobs/edit-job",
        component: EmployerEditAJobPage,
      },
  {
        path: "/employer/find-job-seekers",
        component: EmployerFindJobSeeker,
      },
      
      {
        path: "/employer/my-jobs",
        component: EmployerMyJobsPage,
      },
   {
        path: "/employer/job-details",
        component: EmployerJobDetailsPage,
      },
      
      {
        path: "/employer/my-jobs/applications",
        component: EmployerMyJobApplicationPage,
      },
      {
        path: "/employer/saved-job-seekers",
        component: EmployerSavedJobSeekersPage,
      },
      {
        path: "/employer/plans-billing",
        component: EmployerPlansBillingPage,
      },
      {
        path: "/employer/settings",
        component: EmployerSettingsPage,
      },



      {
        path: "/admin/overview",
        component: AdminOverviewPage,
      },
      {
        path: "/admin/manage-job-seekers",
        component: AdminManageJobSeekersPage,
      },
      {
        path: "/admin/manage-employers",
        component: AdminManageEmployersPage,
      },
      {
        path: "/admin/manage-jobs",
        component: AdminManageJobsPage,
      },
      {
        path: "/admin/content-management",
        component: AdminContentManagementPage,
      },
      {
        path: "/admin/subscription-and-plans",
        component: AdminSubscriptionAndPlansPage,
      },
      {
        path: "/admin/ads",
        component: AdminAdsPage,
      },
      {
        path: "/admin/support-center",
        component: AdminSupportCenterPage,
      },
      {
        path: "/admin/settings",
        component: AdminSettingsPage,
      },

];

export default routes;
